import { fetchRest, getApiBaseUrl } from "@/config/api";

export interface NewsItem {
  id: number;
  title: string;
  content: string;
  type: string | null;
  dateCreation: string | null;
  expiryDate: string | null;
  published: number;
  titleColor: string | null;
  titleFontSize: string | null;
  bgColor: string | null;
}

export interface CreateNewsPayload {
  title: string;
  content: string;
  type?: string;
  expiryDate?: string;
  published?: number;
  titleColor?: string;
  titleFontSize?: string;
  bgColor?: string;
}

/** Vendor Dashboard — active announcements */
export async function getActiveAnnouncements(): Promise<NewsItem[]> {
  const res = await fetchRest(`${getApiBaseUrl()}/announcements/active`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    skipAuthRedirect: true,
  });
  if (!res.ok) return [];
  return res.json();
}

/** Admin CRUD */
export async function getAllAnnouncements(): Promise<NewsItem[]> {
  const res = await fetchRest(`${getApiBaseUrl()}/announcements/admin/all`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function createAnnouncement(
  data: CreateNewsPayload,
): Promise<NewsItem> {
  const res = await fetchRest(`${getApiBaseUrl()}/announcements/admin/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function updateAnnouncement(
  id: number,
  data: Partial<CreateNewsPayload>,
): Promise<NewsItem> {
  const res = await fetchRest(`${getApiBaseUrl()}/announcements/admin/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function deleteAnnouncement(id: number): Promise<void> {
  const res = await fetchRest(`${getApiBaseUrl()}/announcements/admin/${id}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
}
